module.exports = __webpack_public_path__ + "img/heading.bbcba67b.svg";